import React from 'react';
import { Link } from 'react-router-dom';

const TestSeries = ({ tests, examTitle }) => {
  const priviousYearPapers = tests.filter(test => test.isPreviousYearPaper);
  const regularTests = tests.filter(test => !test.isPreviousYearPaper);

  return (
    <div className="test-series-container">
      {priviousYearPapers.length > 0 && (
        <>
          <div className="test-series-header">
            <h2>Previous Year Question Papers for {examTitle}</h2>
            <p>Practice with previous year papers to ace your exam:</p>
          </div>
          <div className="test-series-grid">
            {priviousYearPapers.map((paper) => (
              <div key={paper.id} className="test-series-card">
                <div className="test-series-content">
                  <h3>{paper.title}</h3>
                  <div className="test-series-meta">
                    <span className="test-duration">
                      <i className="fas fa-clock"></i> {paper.duration}
                    </span>
                    <span className="test-marks">
                      <i className="fas fa-star"></i> {paper.marks} Marks
                    </span>
                    <span className="test-questions">
                      <i className="fas fa-question"></i> {paper.questions} Questions
                    </span>
                  </div>
                </div>
                <div className="test-series-action">
                  <div className="test-series-price">Free</div>
                  <Link to={paper.link} className="test-series-button">
                    View Paper
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </>
      )}

      {/* Other Papers */}
      {regularTests.length > 0 && (
        <>
          <div className="test-series-header mt-4">
            <h2>Practice Papers & Mock Tests for {examTitle}</h2>
            <p>Boost your preparation with practice/mock papers:</p>
          </div>
          <div className="test-series-grid">
            {regularTests.map((paper) => (
              <div key={paper.id} className="test-series-card">
                <div className="test-series-content">
                  <h3>{paper.title}</h3>
                  <div className="test-series-meta">
                    <span className="test-duration">
                      <i className="fas fa-clock"></i> {paper.duration}
                    </span>
                    <span className="test-marks">
                      <i className="fas fa-star"></i> {paper.marks} Marks
                    </span>
                    <span className="test-questions">
                      <i className="fas fa-question"></i> {paper.questions} Questions
                    </span>
                  </div>
                </div>
                <div className="test-series-action">
                  <div className="test-series-price">Free</div>
                  <Link to={paper.link} className="test-series-button">
                    View Paper
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </>
      )}

      {tests.length === 0 && (
        <div className="no-tests-message">
          <p>No test  available for this exam yet.</p>
        </div>
      )}
    </div>
  );
};

export default TestSeries;